import { Wizard } from 'domain/wizard/wizard'
import { adminHttpClient } from '../../../commons/adminHttpClient'

const getClassDesignWizard = (productId: string): Promise<Wizard> => {
  return adminHttpClient.get(`Benefit/BenefitRenewal/Ichra/ClassDesignWizard/${productId}`)
}

export default getClassDesignWizard
